import * as XLSX from "xlsx";
import { fmtDate } from "./api";

const save = (sheets, filename) => {
  const wb = XLSX.utils.book_new();
  sheets.forEach(([name, rows]) => XLSX.utils.book_append_sheet(wb, XLSX.utils.json_to_sheet(rows), name));
  XLSX.writeFile(wb, filename);
};

export function exportEntriesExcel({ site, data, branchMap }) {
  const rows = data.entries.map((e, i) => ({
    "#": i + 1, Date: fmtDate(e.date), Branch: branchMap[e.branch_id] || "-", Description: e.description || "",
    Mode: e.mode, Deposit: e.type === "deposit" ? e.amount : "", Withdraw: e.type === "withdraw" ? e.amount : "", "Created by": e.created_by_name || "Admin",
  }));
  rows.push({ Mode: "Total", Deposit: data.total_deposit, Withdraw: data.total_withdraw });
  rows.push({ Mode: "Net", Deposit: data.balance });
  const byDay = {};
  data.entries.forEach((e) => {
    const d = (byDay[e.date] ||= { Date: fmtDate(e.date), Entries: 0, Deposit: 0, Withdraw: 0 });
    d.Entries += 1;
    d[e.type === "deposit" ? "Deposit" : "Withdraw"] += e.amount;
  });
  const days = Object.keys(byDay).sort().map((k) => ({ ...byDay[k], Net: byDay[k].Deposit - byDay[k].Withdraw }));
  save([["Entries", rows], ["Day-wise", days]], `${site.name.replace(/\s+/g, "_")}_entries.xlsx`);
}

export function exportOverviewExcel({ data }) {
  const books = data.sites.map((s) => ({ Book: s.name, Branches: s.branch_count, Entries: s.entry_count, Deposit: s.total_deposit, Withdraw: s.total_withdraw, Net: s.balance }));
  books.push({ Book: "Total", Deposit: data.total_deposit, Withdraw: data.total_withdraw, Net: data.balance });
  const days = data.days.map((d) => ({ Date: fmtDate(d.date), Entries: d.entry_count, Deposit: d.deposit, Withdraw: d.withdraw, Net: d.net }));
  save([["Book-wise", books], ["Day-wise", days]], "dashboard_summary.xlsx");
}

export function exportDayExcel(day) {
  const rows = day.entries.map((e) => ({ Book: e.site_name, Branch: e.branch_name, Description: e.description, Mode: e.mode,
    Deposit: e.type === "deposit" ? e.amount : "", Withdraw: e.type === "withdraw" ? e.amount : "" }));
  rows.push({ Mode: "Total", Deposit: day.total_deposit, Withdraw: day.total_withdraw });
  save([[fmtDate(day.date), rows]], `entries_${day.date}.xlsx`);
}
